const seedRateDisplayUnit = (unit: string): string =>
  unit.toLowerCase() === "seeds/ha" ? "s/ha" : unit;

export default seedRateDisplayUnit;
